import { PAY_BLOCK_ERROR } from '@/constants';

export default {
  common: {
    colon: '：',
    close: '关闭',
    jpy: '<0>JPY</0> <1>{{amount}}</1>',
    error: '错误',
    contact: '洽询',
    delete: '删除',
    cancel: '取消'
  },
  email: {
    subject: '关于（{{orderId}}）订单',
    orderId: '订单号码: {{orderId}}',
    contact: '负责人您好，\n<请于下方输入洽询内容。 >'
  },
  account: {
    title: '付款方式管理',
    caption: '已登录的信用卡',
    tips: '※最多可登录5张信用卡。',
    deleteCardSuccess: '已删除此信用卡。',
    unregistered: '未注册任何信用卡。',
    deleteTitle: '删除确认',
    deleteTips: '确认删除信用卡？'
  },
  order: {
    paymentNumber: '支付编号',
    totalPrice: '总金额',
    useAvailableCard: '使用已登录的信用卡',
    useNewCard: '使用新的信用卡',
    acceptedPayment: '可使用的付款方式',
    email: '电子邮箱',
    deadline: '付款期限',
    pay: 'JPY {{amount}} 支付',
    error: '购买程序发生错误！错误代码：{{code}}',
    secure: '3D Secure',
    secureMessage:
      '如欲使用本公司的服务，必须使用<a>本人验证服务「3D Secure 2.0（EMV 3D Secure）」</a> 。',
    saveCardInfo: '保存卡片信息',
    creditCardVerified: '已完成信用卡确认。',
    incompleteOrder: '订单尚未完成。',
    clickToConfirm: '请务必点选下方确认钮。',
    confirmOrder: '确认订单',
    countdown: '（ {{count}} 秒）',
    paymentError: '付款程序发生错误。',
    confirmDeadline: '请确认订单资讯是否正确及有效期限。',
    orderSuccess: '已确认到此订单',
    orderSuccessSubText: '感谢您的使用',
    orderRefunded: '订单已取消。',
    refunded: '已退款',
    contact: '若问题仍未解决、\n 请点选「洽询」选项洽询。',
    backShop: '返回商品页面',
    paymentDetails: '付款详细',
    paymentLogs: '付款履历',
    print: '打印目前页面',
    creditCard: '信用卡/借记卡',
    addCard: '添加卡片',
    paymentMethod: '支付方式',
    wechatPay: '微信支付',
    alipay: '支付宝',
    paypay: 'PayPay',
    scanWith: '使用{{method}}扫描',
    paypayNoticeLead: '完成支付手续后（PayPay支付音之后）',
    paypayNoticeTitle: '请不要关闭页面并等待',
    paypayNoticeDescription: '显示预约详情页面后，即表示购买完成。',
    paypayNoticeExample: '（显示示例：ARS_********-********.****）',
    paypayNoticeConfirm: '确认上述内容后，打开 PayPay'
  },
  product: {
    dateTime: '日期时间',
    name: '种类',
    price: '单价',
    quantity: '数量',
    total: '金额'
  },
  transaction: {
    timestamp: '时间',
    status: '状态',
    message: '详细信息',
    charge: '付款'
  },
  card: {
    cardNumber: '卡号',
    cardExpiry: '有效期限',
    cardCvc: '安全码',
    cardName: '信用卡上的名称'
  },
  footer: {
    terms: '利用条约',
    privacy: '隐私权政策',
    faq: '常见疑问'
  },
  error: {
    invalidCardNumber: '此卡号无效。',
    invalidCardType: '此卡型无效。',
    invalidCardExpiry: '有效期限错误。',
    pastCardExpiry: '信用卡已过有效期限。',
    invalidCardCvc: '验证码无效。',
    invalidCardName: '请以半形字母输入姓名。'
  },
  payError: {
    [PAY_BLOCK_ERROR.jpCardIssued]:
      '该商品仅面向海外顾客，无法使用日本发行的信用卡，请改用海外发行的信用卡。',
    [PAY_BLOCK_ERROR.nonJpCardIssued]:
      '该商品仅面向日本国内顾客，无法使用海外发行的信用卡，请改用日本国内发行的信用卡。'
  }
};
